/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Label_NameInputs */

const en_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const es_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const de_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const zh_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名`)
};

const ar_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاسم`)
};

const fr_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const vi_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên`)
};

const sw_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jina`)
};

const th_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อ`)
};

const bs_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ime`)
};

const ja_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お名前`)
};

const ko_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이름`)
};

const pt_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const it_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const sv_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namn`)
};

const nl_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam`)
};

const da_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navn`)
};

const nb_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navn`)
};

const fi_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nimi`)
};

const pl_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imię`)
};

const ru_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя`)
};

const tr_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adınız`)
};

const hi_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम`)
};

const id_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama`)
};

const ms_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama`)
};

const cs_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jméno`)
};

const el_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Όνομα`)
};

const he_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שם`)
};

const af_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam`)
};

const hu_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Név`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Contact_Label_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_label_name = /** @type {((inputs?: Contact_Label_NameInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Label_NameInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_label_name(inputs)
	if (locale === "de") return de_contact_label_name(inputs)
	if (locale === "zh") return zh_contact_label_name(inputs)
	if (locale === "ar") return ar_contact_label_name(inputs)
	if (locale === "fr") return fr_contact_label_name(inputs)
	if (locale === "vi") return vi_contact_label_name(inputs)
	if (locale === "sw") return sw_contact_label_name(inputs)
	if (locale === "th") return th_contact_label_name(inputs)
	if (locale === "bs") return bs_contact_label_name(inputs)
	if (locale === "ja") return ja_contact_label_name(inputs)
	if (locale === "ko") return ko_contact_label_name(inputs)
	if (locale === "pt") return pt_contact_label_name(inputs)
	if (locale === "it") return it_contact_label_name(inputs)
	if (locale === "sv") return sv_contact_label_name(inputs)
	if (locale === "nl") return nl_contact_label_name(inputs)
	if (locale === "da") return da_contact_label_name(inputs)
	if (locale === "nb") return nb_contact_label_name(inputs)
	if (locale === "fi") return fi_contact_label_name(inputs)
	if (locale === "pl") return pl_contact_label_name(inputs)
	if (locale === "ru") return ru_contact_label_name(inputs)
	if (locale === "tr") return tr_contact_label_name(inputs)
	if (locale === "hi") return hi_contact_label_name(inputs)
	if (locale === "id") return id_contact_label_name(inputs)
	if (locale === "ms") return ms_contact_label_name(inputs)
	if (locale === "cs") return cs_contact_label_name(inputs)
	if (locale === "el") return el_contact_label_name(inputs)
	if (locale === "he") return he_contact_label_name(inputs)
	if (locale === "af") return af_contact_label_name(inputs)
	if (locale === "hu") return hu_contact_label_name(inputs)
	return en_contact_label_name(inputs)
});